import {Grid} from "@mui/material"
import { MainCategoryContainerStyled, CategoryContainerStyled, CategoryHeaderStyled, CategoryHeaderArStyled,  CategorySubHeaderStyled, CategorySubHeaderArStyled, CategoryGridStyled, ItemContainerStyled, ItemImageContainer, ItemBoxTwoStyled, ItemDetailsContainer, ItemDetailsStyled, ItemDetailsArStyled,  ItemPriceContainer, ItemPriceContainerAr, ItemNameStyled, ItemNameArStyled } from "./generalStyles";
import sandwiches from "../../../data/wcsAspireCategories/sandwiches"

function SandwichesGrid({triggerLanguage}) {
    const reversedPairs = sandwiches.reduce((acc, _, index, arr)=> {
        if(index %2 === 1) {
            acc.push(arr[index], arr[index-1]);
        }
        return acc
    }, []);

    if(triggerLanguage == "en") {
        return (
            <MainCategoryContainerStyled>
                <CategoryContainerStyled>
                ALL DAY SANDWICHES
                </CategoryContainerStyled>
                <CategoryGridStyled>
                    <Grid container spacing = {2} rowSpacing = {4}>
                        {sandwiches.map(({name, description, price_en, img_path}) => {
                            return (
                                <Grid item xs = {6} sm = {6}>
                                    <ItemContainerStyled>
                                        <ItemImageContainer>
                                            <img src = {img_path} />
                                        </ItemImageContainer>
                                            <ItemBoxTwoStyled>
                                                <ItemDetailsContainer>
                                                    <div>
                                                        <ItemNameStyled>
                                                                {name}
                                                        </ItemNameStyled>
                                                        <ItemDetailsStyled>{description}</ItemDetailsStyled>
                                                    </div>
                                                </ItemDetailsContainer>
                                                <ItemPriceContainer>
                                                    {price_en} <span>QR</span>
                                            </ItemPriceContainer>
                                        </ItemBoxTwoStyled>
                                    </ItemContainerStyled>
                                </Grid>
                            )
                        })}
                    </Grid>
                </CategoryGridStyled>
            </MainCategoryContainerStyled>
        )
    }

    if(triggerLanguage == "ar") {
        return (
            <MainCategoryContainerStyled>
                <CategoryContainerStyled>
                    <CategoryHeaderArStyled>
                    ندويشات طول اليوم 
                    </CategoryHeaderArStyled>
                    {/* <CategorySubHeaderStyled>
                        Sub Header one
                    </CategorySubHeaderStyled> */}
                    <CategoryGridStyled>
                        <Grid container spacing = {2} rowSpacing = {4}>
                        {
                            reversedPairs.map(({name_ar, description_ar, price_en, img_path}) => {
                                return (
                                    <Grid item xs = {6} sm = {6}>
                                        <ItemContainerStyled>
                                            <ItemImageContainer>
                                                <img src = {img_path} />
                                            </ItemImageContainer>
                                            <ItemBoxTwoStyled>
                                                <ItemPriceContainerAr>
                                                    <div>{price_en}</div>
                                                    <div><span>ر.ق</span></div>   
                                                </ItemPriceContainerAr>
                                                <ItemDetailsContainer style = {{textAlign: "right"}}>
                                                    <div>
                                                        <ItemNameArStyled>
                                                            {name_ar}
                                                        </ItemNameArStyled>
                                                        <ItemDetailsArStyled>{description_ar}</ItemDetailsArStyled>
                                                    </div>
                                                </ItemDetailsContainer>
                                            </ItemBoxTwoStyled>
                                        </ItemContainerStyled>
                                    </Grid>
                                )
                            })
                        }
                        </Grid>
                    </CategoryGridStyled>
                </CategoryContainerStyled>
            </MainCategoryContainerStyled>
        )
    }
}

export default SandwichesGrid;